'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactUtils = require('react-utils');

exports.default = (0, _reactUtils.keyMirror)({
  UNINITIALIZED: null,
  PENDING: null,
  SUCCEEDED: null,
  FAILED: null
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-1.79/js/constants/RequestStatusTypes.js
// module id = 26
// module chunks = 0 1